import React from 'react';
import {
  IDailyConfig,
  IBreakConfig,
} from '../interfaces/schedule-period.interface';
import { TimeRangePicker, Switcher, DefaultButton } from 'shared/ui';
import { BreakInput } from './break-input';
import styles from './settings.module.scss';

interface IDailyFormProps {
  value: IDailyConfig;
  onChange: (value: IDailyConfig) => void;
}

export const DailyForm: React.FC<IDailyFormProps> = ({ value, onChange }) => {
  const is24h = value.startedAt === '00:00' && value.finishedAt === '00:00';

  return (
    <div className={styles.form_content}>
      <div className={styles.settings__line}>
        <div className={styles.line__text}>Время работы</div>
        <TimeRangePicker
          timeRange={{ start: value.startedAt, end: value.finishedAt }}
          onChange={(data) =>
            onChange({
              ...value,
              startedAt: data.timeRange.start || value.startedAt,
              finishedAt: data.timeRange.end || value.finishedAt,
            })
          }
          index={0}
        />
        <div className={styles.line__text}>24ч.</div>
        <Switcher
          isActive={is24h}
          onClick={() => {
            if (is24h) {
              onChange({ ...value, startedAt: '09:00', finishedAt: '18:00' });
            } else {
              onChange({ ...value, startedAt: '00:00', finishedAt: '00:00' });
            }
          }}
        />
      </div>

      <div className={styles.breaks_section}>
        <div className={styles.breaks_section__title}>Перерывы</div>
        {value.breaks.map((br, i) => (
          <BreakInput
            key={i}
            value={br}
            onChange={(newBr) => {
              const breaks = [...value.breaks];
              breaks[i] = newBr;
              onChange({ ...value, breaks });
            }}
            onDelete={() => {
              const breaks = value.breaks.filter((_, idx) => idx !== i);
              onChange({ ...value, breaks });
            }}
          />
        ))}
        <DefaultButton
          buttonText="+ Добавить перерыв"
          color="green"
          className={styles.add_break_btn}
          onClick={() => {
            const newBreak: IBreakConfig = {
              title: 'Перерыв',
              start: '13:00',
              end: '13:30',
            };
            onChange({ ...value, breaks: [...value.breaks, newBreak] });
          }}
        />
      </div>
    </div>
  );
};
